import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { InvitationResolver } from "./invitation.resolver";
import { VerifyEmailResolver } from "./verify-email.resolver";

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [VerifyEmailResolver, InvitationResolver],
})
export class ResolversModule {}
